import FacebookShare from './facebookShare';
import TwitterShare from './twitterShare';
import LinkedInShare from './linkedInShare';

export default {
    FacebookShare,
    TwitterShare,
    LinkedInShare
};
